import topTitle from '@/components/title';
export default {
  components: {
    topTitle
  },
  props: {
    payoutInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  }
};